<template>
    <div class="categories-tag" v-if="selectedOptions">
        <TotemTag
            v-for="(tag) in selectedOptions"
            :name="tag.label"
            :key="tag.id"
            @handleClick="$emit('handleClick', tag)"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters ({
                selectedOptions: 'CourseFilter/getSelectedCategories'
            })
        }
    }
</script>

<style lang="scss" scoped>
    .categories-tag {
        display: flex;
        flex-wrap: wrap;
    }
</style>
